import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':workOrderId'}/approveReview`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId/approveReview`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/${workOrderId}/approveReview`;
